/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { useDoctorsData } from "../../../providers/doctorsData";
import { IDoctorSpecialty } from "../../../providers/doctorsData/types";

import { Skeleton } from "@mui/material";
import { AllSpecsModal } from "../../Modals/AllSpecs";

export const MainSpecs = () => {
  const { allSpecs, searching } = useDoctorsData();
  const [searchParams, setSearchParams] = useSearchParams();

  const isSwipping = useRef(false);

  const [allSpecModal, setAllSpecsModal] = useState<boolean>(false);

  const handleSearch = (spec: IDoctorSpecialty) => {
    if (isSwipping.current) {
      return;
    }

    // Atualiza URL ao trocar especialidade
    searchParams.set("spec", spec.key.name);
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);

  };

  const sortSpecs = useMemo(() => {
    return allSpecs.sort((a, b) => a.value - b.value).reverse();
  }, [allSpecs]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    accessibility: true,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    variableWidth: true,
    onSwipe: () => {
      // console.log("onSwipe");
      isSwipping.current = true;
      // Reset após um tempo se não houver mudança de slide
      setTimeout(() => {
        if (isSwipping.current) {
          isSwipping.current = false;
        }
      }, 300);
    },
    beforeChange: () => {
      // console.log("beforeChange");
      isSwipping.current = true;
    },
    afterChange: () => {
      // console.log("afterChange");
      // Pequeno delay para garantir que o clique não seja disparado
      setTimeout(() => {
        isSwipping.current = false;
      }, 100);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          draggable: true,
          dots: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="especialidades">
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-lg">
              <h3 className="mb-3 medium">Especialidades mais buscadas</h3>
              <a
                role="button"
                className="text-primary text-decoration-none"
                onClick={() => setAllSpecsModal(true)}
              >
                Listar Todas <i className="las la-angle-right"></i>
              </a>
            </div>
            <div className="col-12 col-lg-9 p-0">
              {!!searching && sortSpecs.length <= 0 && (
                <div className="d-flex flex-nowrap gap-2 py-2">
                  <Skeleton variant="rectangular" className="card bg-white" height={65} width={160} />
                  <Skeleton variant="rectangular" className="card bg-white" height={65} width={190} />
                  <Skeleton variant="rectangular" className="card bg-white" height={65} width={180} />
                  <Skeleton variant="rectangular" className="card bg-white" height={65} width={130} />
                  <Skeleton variant="rectangular" className="card bg-white" height={65} width={140} />
                </div>
              )}
              {!searching && sortSpecs.length == 0 && (
                <p className="text-center">Nenhuma especialidade cadastrada.</p>
              )}
              {(!searching && sortSpecs.length !== 0) && (
                <Slider {...settings}>
                  {sortSpecs.map((elm, index) => (
                    <div
                      onClick={() => handleSearch(elm)}
                      key={index}
                      className="carousel-cell py-2"
                    >
                      <div className={`btn ${elm.key.name == searchParams.get("spec") ? 'btn-primary' : 'btn-outline-secondary bg-white'} rounded-4 text-start px-3 py-2 ms-2`}>
                        <h6 className="mb-1">{elm.key.name}</h6>
                        <p className="mb-0">
                          {elm.value} {elm.value === 1 ? "médico" : "médicos"}
                        </p>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        </div>
      </div>

      {allSpecModal && (
        <AllSpecsModal
          specs={sortSpecs}
          modal={allSpecModal}
          closeModal={() => setAllSpecsModal(false)}
        />
      )}
    </>
  );
};
